// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PharmacyCardFinderV2InputRequestModel } from './pharmacyCardFinderV2InputRequestModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PharmacyCardFinderV2RequestModel {
    'inputModel': PharmacyCardFinderV2InputRequestModel | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PharmacyCardFinderV2RequestModel>> = [
        {
            "name":     "inputModel",
            "baseName": "inputModel",
            "type":     "PharmacyCardFinderV2InputRequestModel"
        },
    ];

    static getAttributeTypeMap() {
        return PharmacyCardFinderV2RequestModel.attributeTypeMap;
    }
}
